import { render } from "./OrderTabs.vue?vue&type=template&id=58794954"
import script from "./OrderTabs.vue?vue&type=script&lang=js"
export * from "./OrderTabs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__